import AddRssFeedContainer from 'modules/posts/containers/AddRssFeedContainer';

const AddRssFeedView = () => <AddRssFeedContainer />;

export default AddRssFeedView;
